import { HttpClient } from "@angular/common/http";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { Config, ConfigEnvService } from "app/shared/configEnvService";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";

declare const $: any;
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  externalLink: boolean;
  children?: RouteInfo[];
  expanded?: boolean;
}
export const ROUTES: RouteInfo[] = [
  {
    path: "/dashboard",
    title: "داشبورد",
    icon: "dashboard",
    class: "",
    externalLink: false,
  },
  {
    path: "",
    title: "تنظیمات",
    icon: "settings",
    class: "",
    externalLink: false,
    children: [
      {
        path: "/settings",
        title: "پیکربندی تنظیمات",
        icon: "settings",
        class: "",
        externalLink: false,
      },
      {
        path: "/settings/network-types",
        title: "شبکه‌ها و اکسپلوررها",
        icon: "account_tree",
        class: "",
        externalLink: false,
      },
      {
        path: "/tracking-site",
        title: "سایت‌های مانیتورینگ",
        icon: "language",
        class: "",
        externalLink: false,
      },
      {
        path: "/settings/token-history-fetch",
        title: "واکشی تاریخچه توکن",
        icon: "history",
        class: "",
        externalLink: false,
      },
    ],
  },

  {
    path: "",
    title: "میم تریدینگ",
    icon: "rocket_launch",
    class: "",
    externalLink: false,
    children: [
      {
        path: "/meme-trading/meme-list",
        title: "لیست میم ها",
        icon: "emoji_emotions",
        class: "",
        externalLink: false,
      },
      {
        path: "/meme-trading/history",
        title: "تاریخچه میم کوین",
        icon: "history",
        class: "",
        externalLink: false,
      },
    ],
  },
  {
    path: "",
    title: "توکن ها",
    icon: "currency_bitcoin",
    class: "",
    externalLink: false,
    children: [
      {
        path: "/coins-list",
        title: "لیست توکن ها",
        icon: "list",
        class: "",
        externalLink: false,
      },
      {
        path: "/suggested-coins-list",
        title: "توکنهای پیشنهادی",
        icon: "bookmark_add",
        class: "",
        externalLink: false,
      },
      {
        path: "/favorite-coins-list",
        title: "توکنهای منتخب",
        icon: "star",
        class: "",
        externalLink: false,
      },
      {
        path: "/history-list",
        title: "تاریخچه توکن ها",
        icon: "history",
        class: "",
        externalLink: false,
      },
    ],
  },

  {
    path: "https://api.mahdinobakht.ir/hangfire",
    title: "مدیریت HangFire",
    icon: "schedule",
    class: "",
    externalLink: true,
  },
  {
    path: "/error-logs-list",
    title: "لیست لاگ ها",
    icon: "error",
    class: "",
    externalLink: false,
  },
];

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit, OnDestroy {
  menuItems: any[];
  private envService;
  private config: Config;
  public baseUrl = "";
  private routeSub: Subscription;

  public appVersion = "0";
  constructor(
    public http: HttpClient,
    envService: ConfigEnvService,
    private router: Router,
  ) {
    this.envService = envService;
    this.config = envService.getConfigData();
    this.baseUrl = this.config.serverUrl;
  }

  ngOnInit() {
    this.menuItems = ROUTES.filter((menuItem) => menuItem);
    this.getAppVersion();
    this.expandActiveParent();

    this.routeSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.expandActiveParent());
  }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }

  private expandActiveParent() {
    const currentPath = this.router.url;
    this.menuItems.forEach((item) => {
      if (item.children) {
        const hasActiveChild = item.children.some((child) =>
          currentPath.startsWith(child.path),
        );
        if (hasActiveChild) {
          item.expanded = true;
        }
      }
    });
  }
  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }

  getAppVersion() {
    return this.http
      .get<any>(`${this.baseUrl}api/General/GetAppVersion`, {})
      .subscribe((data: any) => {
        if (data.isSuccess) {
          this.appVersion = data.value;
        } else this.appVersion = "0";
      });
  }
}
